<div class="chart-section">
  <div class="section-header">
    <div class="section-icon activity">
      <i class="bi bi-activity"></i>
    </div>
    <h2 class="section-title">Activity Analysis</h2>
  </div>

  <div class="section-card">
    <!-- Tabs -->
    <div class="section-tabs">
      <button class="tab" [class.active]="typeMedia === 1" (click)="setTypeMedia(1)">
        <i class="bi bi-graph-up"></i> Profile activity
        <a class="info-tip" data-tooltip="Posting frequency"><i class="bi bi-info-circle"></i></a>
      </button>
      <button class="tab" [class.active]="typeMedia === 2" (click)="setTypeMedia(2)">
        <i class="bi bi-people"></i> Followers activity
        <a class="info-tip" data-tooltip="Content activity of followers of the audited profile"><i class="bi bi-info-circle"></i></a>
      </button>
    </div>

    <!-- Loading -->
    <app-loader *ngIf="!(profileState | async).loader['audit']['mediaAnalyze']" size="sm" message="Analyzing activity..."></app-loader>

    <div [class.dimmed]="!(profileState | async).loader['audit']['mediaAnalyze']">
      <div class="chart-grid">
        <!-- Popular hashtags -->
        <div class="chart-cell">
          <div class="chart-cell-header">
            <h3>
              <i class="bi bi-hash cell-icon text-blue"></i>
              Popular hashtags
              <a class="info-tip" data-tooltip="Most commonly used hashtags on the audited profile"><i class="bi bi-info-circle"></i></a>
            </h3>
          </div>
          <div *ngIf="chartsMediaAnalyze !== undefined">
            <div [chart]="chartsMediaAnalyze[5]"></div>
          </div>
        </div>

        <!-- Popular tags -->
        <div class="chart-cell">
          <div class="chart-cell-header">
            <h3>
              <i class="bi bi-at cell-icon text-purple"></i>
              Popular tags
              <a class="info-tip" data-tooltip="Most commonly used tags on the audited profile"><i class="bi bi-info-circle"></i></a>
            </h3>
          </div>
          <div *ngIf="chartsMediaAnalyze !== undefined">
            <div [chart]="chartsMediaAnalyze[6]"></div>
          </div>
        </div>

        <!-- Activity by week days -->
        <div class="chart-cell">
          <div class="chart-cell-header">
            <h3>
              <i class="bi bi-calendar-week cell-icon text-green"></i>
              Activity by week days
              <a class="info-tip" data-tooltip="Content activity by days of the week"><i class="bi bi-info-circle"></i></a>
            </h3>
          </div>
          <div *ngIf="chartsMediaAnalyze !== undefined">
            <div [chart]="chartsMediaAnalyze[4]"></div>
          </div>
        </div>

        <!-- Activity by hours -->
        <div class="chart-cell">
          <div class="chart-cell-header">
            <h3>
              <i class="bi bi-clock cell-icon text-coral"></i>
              Activity by hours
              <span class="tz-badge">{{timezone}} GMT</span>
              <a class="info-tip" data-tooltip="Content activity by hours"><i class="bi bi-info-circle"></i></a>
            </h3>
          </div>
          <div *ngIf="chartsMediaAnalyze !== undefined">
            <div [chart]="chartsMediaAnalyze[3]"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>